module.exports = __webpack_public_path__ + "img/21.f2f5b88e.jpg";